/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { Icd10Model } from '../models/icd-10-model';
import { patientCaseIcdUpdatePost } from '../fn/patient/patient-case-icd-update-post';
import { PatientCaseIcdUpdatePost$Params } from '../fn/patient/patient-case-icd-update-post';
import { patientCaseListPatientIdGet } from '../fn/patient/patient-case-list-patient-id-get';
import { PatientCaseListPatientIdGet$Params } from '../fn/patient/patient-case-list-patient-id-get';
import { PatientCaseModel } from '../models/patient-case-model';
import { patientClinicGroupIdPatientSearchPost } from '../fn/patient/patient-clinic-group-id-patient-search-post';
import { PatientClinicGroupIdPatientSearchPost$Params } from '../fn/patient/patient-clinic-group-id-patient-search-post';
import { patientClinicGroupIdPatientsIndexPageSizeGet } from '../fn/patient/patient-clinic-group-id-patients-index-page-size-get';
import { PatientClinicGroupIdPatientsIndexPageSizeGet$Params } from '../fn/patient/patient-clinic-group-id-patients-index-page-size-get';
import { patientClinicGroupIdPost } from '../fn/patient/patient-clinic-group-id-post';
import { PatientClinicGroupIdPost$Params } from '../fn/patient/patient-clinic-group-id-post';
import { patientCloseCasePost } from '../fn/patient/patient-close-case-post';
import { PatientCloseCasePost$Params } from '../fn/patient/patient-close-case-post';
import { PatientEncounterDetailModel } from '../models/patient-encounter-detail-model';
import { PatientEncounterHistoryModel } from '../models/patient-encounter-history-model';
import { patientEncounterHistoryPatientIdCaseIdGet } from '../fn/patient/patient-encounter-history-patient-id-case-id-get';
import { PatientEncounterHistoryPatientIdCaseIdGet$Params } from '../fn/patient/patient-encounter-history-patient-id-case-id-get';
import { patientEncounterHistoryPatientIdGet } from '../fn/patient/patient-encounter-history-patient-id-get';
import { PatientEncounterHistoryPatientIdGet$Params } from '../fn/patient/patient-encounter-history-patient-id-get';
import { PatientEncounterPartHistoryModel } from '../models/patient-encounter-part-history-model';
import { patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet } from '../fn/patient/patient-facility-id-encounter-history-by-part-patient-id-anatomy-part-id-get';
import { PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Params } from '../fn/patient/patient-facility-id-encounter-history-by-part-patient-id-anatomy-part-id-get';
import { patientFacilityIdEncountersPatientIdIndexPageSizeGet } from '../fn/patient/patient-facility-id-encounters-patient-id-index-page-size-get';
import { PatientFacilityIdEncountersPatientIdIndexPageSizeGet$Params } from '../fn/patient/patient-facility-id-encounters-patient-id-index-page-size-get';
import { patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet } from '../fn/patient/patient-facility-id-patient-encounter-part-history-patient-id-anatomy-part-id-get';
import { PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Params } from '../fn/patient/patient-facility-id-patient-encounter-part-history-patient-id-anatomy-part-id-get';
import { patientIdGet } from '../fn/patient/patient-id-get';
import { PatientIdGet$Params } from '../fn/patient/patient-id-get';
import { PatientModel } from '../models/patient-model';
import { PatientModelSearchResultModel } from '../models/patient-model-search-result-model';
import { patientOpenCasePost } from '../fn/patient/patient-open-case-post';
import { PatientOpenCasePost$Params } from '../fn/patient/patient-open-case-post';
import { patientPatientEncounterDetailPatientIdGet } from '../fn/patient/patient-patient-encounter-detail-patient-id-get';
import { PatientPatientEncounterDetailPatientIdGet$Params } from '../fn/patient/patient-patient-encounter-detail-patient-id-get';
import { patientPrimaryPracticePost } from '../fn/patient/patient-primary-practice-post';
import { PatientPrimaryPracticePost$Params } from '../fn/patient/patient-primary-practice-post';
import { patientPrimaryPractitionerPost } from '../fn/patient/patient-primary-practitioner-post';
import { PatientPrimaryPractitionerPost$Params } from '../fn/patient/patient-primary-practitioner-post';
import { PatientSearchEncounterModel } from '../models/patient-search-encounter-model';
import { PatientSearchResultModel } from '../models/patient-search-result-model';

@Injectable({ providedIn: 'root' })
export class PracticePatientService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientIdGet()` */
  static readonly PatientIdGetPath = '/Patient/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientIdGet$Response(params: PatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
    const obs = patientIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientIdGet(params: PatientIdGet$Params, context?: HttpContext): Observable<PatientModel> {
    const resp = this.patientIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientModel>): PatientModel => r.body)
    );
  }

  /** Path part for operation `patientPatientEncounterDetailPatientIdGet()` */
  static readonly PatientPatientEncounterDetailPatientIdGetPath = '/Patient/PatientEncounterDetail/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientPatientEncounterDetailPatientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientPatientEncounterDetailPatientIdGet$Response(params: PatientPatientEncounterDetailPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterDetailModel>> {
    const obs = patientPatientEncounterDetailPatientIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientPatientEncounterDetailPatientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientPatientEncounterDetailPatientIdGet(params: PatientPatientEncounterDetailPatientIdGet$Params, context?: HttpContext): Observable<PatientEncounterDetailModel> {
    const resp = this.patientPatientEncounterDetailPatientIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientEncounterDetailModel>): PatientEncounterDetailModel => r.body)
    );
  }

  /** Path part for operation `patientClinicGroupIdPost()` */
  static readonly PatientClinicGroupIdPostPath = '/Patient/{clinicGroupId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientClinicGroupIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientClinicGroupIdPost$Response(params: PatientClinicGroupIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
    const obs = patientClinicGroupIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientClinicGroupIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientClinicGroupIdPost(params: PatientClinicGroupIdPost$Params, context?: HttpContext): Observable<PatientModel> {
    const resp = this.patientClinicGroupIdPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientModel>): PatientModel => r.body)
    );
  }

  /** Path part for operation `patientPrimaryPractitionerPost()` */
  static readonly PatientPrimaryPractitionerPostPath = '/Patient/PrimaryPractitioner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientPrimaryPractitionerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientPrimaryPractitionerPost$Response(params?: PatientPrimaryPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
    const obs = patientPrimaryPractitionerPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientPrimaryPractitionerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientPrimaryPractitionerPost(params?: PatientPrimaryPractitionerPost$Params, context?: HttpContext): Observable<PatientModel> {
    const resp = this.patientPrimaryPractitionerPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientModel>): PatientModel => r.body)
    );
  }

  /** Path part for operation `patientPrimaryPracticePost()` */
  static readonly PatientPrimaryPracticePostPath = '/Patient/PrimaryPractice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientPrimaryPracticePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientPrimaryPracticePost$Response(params?: PatientPrimaryPracticePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
    const obs = patientPrimaryPracticePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientPrimaryPracticePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientPrimaryPracticePost(params?: PatientPrimaryPracticePost$Params, context?: HttpContext): Observable<PatientModel> {
    const resp = this.patientPrimaryPracticePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientModel>): PatientModel => r.body)
    );
  }

  /** Path part for operation `patientClinicGroupIdPatientSearchPost()` */
  static readonly PatientClinicGroupIdPatientSearchPostPath = '/Patient/{clinicGroupId}/PatientSearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientClinicGroupIdPatientSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientClinicGroupIdPatientSearchPost$Response(params: PatientClinicGroupIdPatientSearchPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModelSearchResultModel>> {
    const obs = patientClinicGroupIdPatientSearchPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientClinicGroupIdPatientSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientClinicGroupIdPatientSearchPost(params: PatientClinicGroupIdPatientSearchPost$Params, context?: HttpContext): Observable<PatientModelSearchResultModel> {
    const resp = this.patientClinicGroupIdPatientSearchPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientModelSearchResultModel>): PatientModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `patientClinicGroupIdPatientsIndexPageSizeGet()` */
  static readonly PatientClinicGroupIdPatientsIndexPageSizeGetPath = '/Patient/{clinicGroupId}/Patients/{index}/{pageSize}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientClinicGroupIdPatientsIndexPageSizeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientClinicGroupIdPatientsIndexPageSizeGet$Response(params: PatientClinicGroupIdPatientsIndexPageSizeGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientSearchResultModel>> {
    const obs = patientClinicGroupIdPatientsIndexPageSizeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientClinicGroupIdPatientsIndexPageSizeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientClinicGroupIdPatientsIndexPageSizeGet(params: PatientClinicGroupIdPatientsIndexPageSizeGet$Params, context?: HttpContext): Observable<PatientSearchResultModel> {
    const resp = this.patientClinicGroupIdPatientsIndexPageSizeGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientSearchResultModel>): PatientSearchResultModel => r.body)
    );
  }

  /** Path part for operation `patientFacilityIdEncountersPatientIdIndexPageSizeGet()` */
  static readonly PatientFacilityIdEncountersPatientIdIndexPageSizeGetPath = '/Patient/{facilityId}/Encounters/{patientId}/{index}/{pageSize}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientFacilityIdEncountersPatientIdIndexPageSizeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdEncountersPatientIdIndexPageSizeGet$Response(params: PatientFacilityIdEncountersPatientIdIndexPageSizeGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientSearchEncounterModel>> {
    const obs = patientFacilityIdEncountersPatientIdIndexPageSizeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientFacilityIdEncountersPatientIdIndexPageSizeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdEncountersPatientIdIndexPageSizeGet(params: PatientFacilityIdEncountersPatientIdIndexPageSizeGet$Params, context?: HttpContext): Observable<PatientSearchEncounterModel> {
    const resp = this.patientFacilityIdEncountersPatientIdIndexPageSizeGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientSearchEncounterModel>): PatientSearchEncounterModel => r.body)
    );
  }

  /** Path part for operation `patientEncounterHistoryPatientIdGet()` */
  static readonly PatientEncounterHistoryPatientIdGetPath = '/Patient/EncounterHistory/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientEncounterHistoryPatientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientEncounterHistoryPatientIdGet$Response(params: PatientEncounterHistoryPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterHistoryModel>> {
    const obs = patientEncounterHistoryPatientIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientEncounterHistoryPatientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientEncounterHistoryPatientIdGet(params: PatientEncounterHistoryPatientIdGet$Params, context?: HttpContext): Observable<PatientEncounterHistoryModel> {
    const resp = this.patientEncounterHistoryPatientIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientEncounterHistoryModel>): PatientEncounterHistoryModel => r.body)
    );
  }

  /** Path part for operation `patientEncounterHistoryPatientIdCaseIdGet()` */
  static readonly PatientEncounterHistoryPatientIdCaseIdGetPath = '/Patient/EncounterHistory/{patientId}/{caseId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientEncounterHistoryPatientIdCaseIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientEncounterHistoryPatientIdCaseIdGet$Response(params: PatientEncounterHistoryPatientIdCaseIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterHistoryModel>> {
    const obs = patientEncounterHistoryPatientIdCaseIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientEncounterHistoryPatientIdCaseIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientEncounterHistoryPatientIdCaseIdGet(params: PatientEncounterHistoryPatientIdCaseIdGet$Params, context?: HttpContext): Observable<PatientEncounterHistoryModel> {
    const resp = this.patientEncounterHistoryPatientIdCaseIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientEncounterHistoryModel>): PatientEncounterHistoryModel => r.body)
    );
  }

  /** Path part for operation `patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet()` */
  static readonly PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGetPath = '/Patient/{facilityId}/EncounterHistoryByPart/{patientId}/{anatomyPartId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Response(params: PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterHistoryModel>> {
    const obs = patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet(params: PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<PatientEncounterHistoryModel> {
    const resp = this.patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientEncounterHistoryModel>): PatientEncounterHistoryModel => r.body)
    );
  }

  /** Path part for operation `patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet()` */
  static readonly PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGetPath = '/Patient/{facilityId}/PatientEncounterPartHistory/{patientId}/{anatomyPartId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Response(params: PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientEncounterPartHistoryModel>>> {
    const obs = patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet(params: PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<Array<PatientEncounterPartHistoryModel>> {
    const resp = this.patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PatientEncounterPartHistoryModel>>): Array<PatientEncounterPartHistoryModel> => r.body)
    );
  }

  /** Path part for operation `patientOpenCasePost()` */
  static readonly PatientOpenCasePostPath = '/Patient/OpenCase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientOpenCasePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientOpenCasePost$Response(params?: PatientOpenCasePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = patientOpenCasePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientOpenCasePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientOpenCasePost(params?: PatientOpenCasePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.patientOpenCasePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientCloseCasePost()` */
  static readonly PatientCloseCasePostPath = '/Patient/CloseCase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientCloseCasePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientCloseCasePost$Response(params?: PatientCloseCasePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientCaseModel>>> {
    const obs = patientCloseCasePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientCloseCasePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientCloseCasePost(params?: PatientCloseCasePost$Params, context?: HttpContext): Observable<Array<PatientCaseModel>> {
    const resp = this.patientCloseCasePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PatientCaseModel>>): Array<PatientCaseModel> => r.body)
    );
  }

  /** Path part for operation `patientCaseListPatientIdGet()` */
  static readonly PatientCaseListPatientIdGetPath = '/Patient/CaseList/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientCaseListPatientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientCaseListPatientIdGet$Response(params: PatientCaseListPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientCaseModel>>> {
    const obs = patientCaseListPatientIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientCaseListPatientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientCaseListPatientIdGet(params: PatientCaseListPatientIdGet$Params, context?: HttpContext): Observable<Array<PatientCaseModel>> {
    const resp = this.patientCaseListPatientIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PatientCaseModel>>): Array<PatientCaseModel> => r.body)
    );
  }

  /** Path part for operation `patientCaseIcdUpdatePost()` */
  static readonly PatientCaseIcdUpdatePostPath = '/Patient/CaseICDUpdate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientCaseIcdUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientCaseIcdUpdatePost$Response(params?: PatientCaseIcdUpdatePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<Icd10Model>>> {
    const obs = patientCaseIcdUpdatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientCaseIcdUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientCaseIcdUpdatePost(params?: PatientCaseIcdUpdatePost$Params, context?: HttpContext): Observable<Array<Icd10Model>> {
    const resp = this.patientCaseIcdUpdatePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<Icd10Model>>): Array<Icd10Model> => r.body)
    );
  }

}
